<div class="row">
  <div class="col">
    <h5 class="title" [ngClass]="{'required': isRequired}" [innerHtml]="getLabel()" ></h5>
    <app-audioplayer *ngIf="formItem?.item?.allowAudio && formItem?.item?.audioFileName != '' && formItem.item?.audioFileName != null " [formItem]="formItem" [formId]="formId"></app-audioplayer>
  </div>
</div>

<!--
<mat-form-field class="dateTimePicker">

  <input
    matInput
    #validationForm="ngModel"
    [required]="isRequired"
    ngModel
    [matDatepicker]="picker"
    [(ngModel)]="this.formItem.value"
    placeholder="{{'Choose a date' | translate}}">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
-->
<div class="col-sm-2">
  <input type="date" class="form-control csc-label" #validationForm="ngModel" [(ngModel)]="this.formItem.value" [required]="isRequired" placeholder="{{'Choose a date' | translate}}"/>
</div>

